const SET_NAV_PROPS = 'SET_NAV_PROPS'
const SET_SUBROUTE = 'SET_SUBROUTE'

export const setNavBarProps = props => ({
    type: SET_NAV_PROPS,
    props
  })

export const setSubroute = subroute => ({
    type: SET_SUBROUTE,
    subroute
  })

const navProps = (state, action = {}) => {
  const currentState = state === undefined ? null : state

  if (action.type === SET_NAV_PROPS) {
    return action.props
  }
  return currentState
}

const subroute = (state, action = {}) => {
  const currentState = state === undefined ? '' : state

  if (action.type === SET_SUBROUTE) {
    return action.subroute
  }
  return currentState
}

export default { navProps, subroute }
